import API from "../../api";

export const getServiceCenter = agency_code => {
  return API.agent().get(`/agencies/${agency_code}/is-service-center`);
};
